export const environment = {
  name: 'cftest',
  production: false,
  baseBEUrl: 'https://api.staging.rxphoto.com/',
  baseAPIUrl: 'https://api.staging.rxphoto.com/api/v2/',
  baseAPIUrlv3: 'https://api.staging.rxphoto.com/api/v3/',
  baseAPIUrlMicro: 'https://service.staging.rxphoto.com/',
  launchDarklyUrl: 'https://ld.staging.rxphoto.com',
  integrationBaseAPIUrlV3: 'https://api.staging.rxphoto.com/integration/api/v3/',
  spcApiUrl: 'https://api-qa.aestheticnow.com/',
  homeRoute: '/',
  drChronoClientId: 'PF6hU7lZLhNcYWO5A14DwCuscRDy0kWKFZtKFgz8',
  ssoBaseUrl: 'https://service.staging.rxphoto.com/sso/auth/',
  localStorage: {
    debug: 'rxphoto.debug',
    prefix: 'rxphoto',
    user: 'rxphoto.user',
    token: 'rxphoto.token',
    remoteToken: 'rxphoto.remoteToken',
    clientId: 'rxphoto.clientId',
    patientId: 'rxphoto.patientId',
    spcAppUserId: 'rxphoto.spcAppUserId',
    userInfo: 'rxphoto.user',
    schedulerToken: 'rxphoto.schedulerToken',
    returnUrl: 'rxphoto.returnUrl',
    patientSort: 'rxphoto.patientSort',
    returnUrlExt: 'rxphoto.returnUrlExt',
    wrap: 'rxphoto.wrap',
    isAltair: 'rxphoto.isAltair',
    version: 'rxphoto.version',
    pendingRefresh: 'rxphoto.refresh',
    featureFlags: 'rxphoto.featureFlags',
    redirectUrl: 'rxphoto.hv-redirectUrl',
    canvaOAuth: 'rxphoto.canvaOAuth',
    canvaOAuthUrl: 'https://service.staging.rxphoto.com/oauth/code',
    lastUserActivity: 'rxphoto.lastUserActivity',
    companyId: 'rxphoto.companyId',
  },
  cookie: {
    storage: 'rxphoto',
    value: '12345678',
    expire: 5,
  },
  staging: true,
  rxAuth: 'https://auth.staging.rxphoto.com',
  rxAdmin: 'https://admin.staging.rxphoto.com',
  rxPhoto: 'https://rxphoto.staging.rxphoto.com/v19/',
  rxForms: 'https://forms.staging.rxphoto.com',
  rxGallery: 'https://gallery.staging.rxphoto.com',
  galleryEmbedHelpUrl:
    'https://help.rxphoto.com/en/articles/17744466-rxphoto-embed-your-rxphoto-gallery-on-your-website',
  rxPortal: 'https://portal.staging.rxphoto.com',
  sentryDSN: 'https://4962098f20dd46989ede655bd04f992b@sentry.rxphoto.com/26',
  default_body_part_id: '439',
  default_sequence_id: 9741,
  subscriptionsUrl: 'https://subscriptions.zoho.com/portal/rxphototesttest/login',

  rxHealthVuAdmin: 'https://rxadmin.staging.health-vu.com',
  rxHealthVuManage: 'https://admin.staging.health-vu.com',
  rxHealthVu: 'https://staging.health-vu.com',

  rxScheduler: 'https://scheduler.staging.rxphoto.com/',

  adsBannerData: 'https://www.patientnow.com/wp-json/patientnow/v1/ads-banner-data',

  doctor_type: 1164,

  churnZeroSrc: 'https://patientnow-dev.us1app.churnzero.net/churnzero.js',
  churnZeroAppKey: '1!9PpyMrQyMTszl4znPILRE1FmHdLpj2gUbiyx0zR2gKUt132C',
  intercomAppId: 'cdv7u3fw',
};
